import { ContentHubType } from 'src/constants';
import { getHubUrl } from 'src/utils/getUrl';

export const getLearningPathsHubPart = (pathname?: string): string => {
  const hubUrl = getHubUrl(ContentHubType.LEARNING_PATHS);
  const isAllLearningPathsHubIncluded = pathname?.includes(hubUrl);

  const allLearningPathsHubPart = isAllLearningPathsHubIncluded ? hubUrl : '';

  return allLearningPathsHubPart;
};
